import React from 'react'
import { Helmet } from 'react-helmet-async'

const Features = () => {
  return (
    <>
      <Helmet>
        <title>
          Church Management Software Features | My Church Directory
        </title>

        <meta
          name="description"
          content="Explore powerful church management software features including member directory, ministries, event scheduling, leadership management, member portal, and push notifications. Everything your church needs to stay connected in one secure platform."
        />
      </Helmet>
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div>
            <img
              src="/images/members.jpg"
              alt="Member Directory"
              className="rounded-2xl shadow-xl w-full"
            />
          </div>

          {/* Content */}
          <div>
            <span className="inline-flex rounded-full bg-sky-100 text-secondary px-3 py-1 text-sm font-medium">
              Member Directory
            </span>

            <h2 className="different_heading mt-4 text-4xl font-bold">
              Keep Every Member Organized
            </h2>

            <p className="mt-5 text-gray-600">
              Manage member profiles, family relationships, volunteer records,
              and communication in one secure place.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              <div>✓ Member Profiles</div>
              <div>✓ Family Management</div>
              <div>✓ Volunteer Records</div>
              <div>✓ Smart Search</div>
              <div>✓ Contact Information</div>
            </div>


          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <span className="inline-flex rounded-full bg-sky-100 text-secondary px-3 py-1 text-sm font-medium">
              Ministries & Groups
            </span>

            <h2 className="different_heading mt-4 text-4xl font-bold">
              Organize Every Ministry with Ease
            </h2>

            <p className="mt-5 text-gray-600">
              Coordinate ministries, small groups, volunteers, and team leaders from one centralized platform to keep your church connected.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              <div>✓ Ministry Management</div>
              <div>✓ Small Groups</div>
              <div>✓ Team Leaders</div>
              <div>✓ Volunteer Scheduling</div>
              <div>✓ Member Assignments</div>
              <div>✓ Group Communication</div>
            </div>


          </div>

          {/* Image */}
          <div>
            <img
              src="/images/ministries.jpg"
              alt="Ministries"
              className="rounded-2xl shadow-xl w-full"
            />
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div>
            <img
              src="/images/schedules.jpg"
              alt="Events"
              className="rounded-2xl shadow-xl w-full"
            />
          </div>

          {/* Content */}
          <div>
            <span className="inline-flex rounded-full bg-sky-100 text-secondary px-3 py-1 text-sm font-medium">
              Events & Schedules
            </span>

            <h2 className="different_heading mt-4 text-4xl font-bold">
              Plan and Manage Church Events
            </h2>

            <p className="mt-5 text-gray-600">
              Create services, conferences, meetings, and recurring events while managing registrations, reminders, and attendance.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              <div>✓ Event Calendar</div>
              <div>✓ Recurring Events</div>
            </div>


          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <span className="inline-flex rounded-full bg-sky-100 text-secondary px-3 py-1 text-sm font-medium">
              Leadership
            </span>

            <h2 className="different_heading mt-4 text-4xl font-bold">
              Empower Church Leaders
            </h2>

            <p className="mt-5 text-gray-600">
              Give pastors, elders, and ministry leaders the tools they need to oversee teams, manage responsibilities, and monitor church growth.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              <div>✓ Role Management</div>
              <div>✓ Staff Directory</div>
              <div>✓ Ministry Oversight</div>
            </div>


          </div>

          {/* Image */}
          <div>
            <img
              src="/images/leadership.jpg"
              alt="Leadership"
              className="rounded-2xl shadow-xl w-full"
            />
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div>
            <img
              src="/images/member_portal.jpg"
              alt="Member Portal"
              className="rounded-2xl shadow-xl w-full"
            />
          </div>

          {/* Content */}
          <div>
            <span className="inline-flex rounded-full bg-sky-100 text-secondary px-3 py-1 text-sm font-medium">
              Member Portal
            </span>

            <h2 className="different_heading mt-4 text-4xl font-bold">
              Keep Members Connected Anytime
            </h2>

            <p className="mt-5 text-gray-600">
              Give members secure access to their profiles, events, groups, giving history, announcements, and church updates from anywhere.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              <div>✓ Personal Profile</div>
              <div>✓ Prayer Requests</div>
              <div>✓ Church Announcements</div>
            </div>


          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <span className="inline-flex rounded-full bg-sky-100 text-secondary px-3 py-1 text-sm font-medium">
              Push Notifications
            </span>

            <h2 className="different_heading mt-4 text-4xl font-bold">
              Deliver Important Updates Instantly
            </h2>

            <p className="mt-5 text-gray-600">
              Send real-time notifications to members for events, announcements, prayer requests, schedule changes, and emergency alerts.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              <div>✓ Instant Alerts</div>
              <div>✓ Event Reminders</div>
              <div>✓ Prayer Updates</div>
              <div>✓ Emergency Messages</div>
              <div>✓ Audience Targeting</div>
            </div>


          </div>

          {/* Image */}
          <div>
            <img
              src="/images/notification.png"
              alt="Push Notifications"
              className="rounded-2xl shadow-xl w-full"
            />
          </div>
        </div>
      </section>
    </>
  )
}

export default Features